// extracted by mini-css-extract-plugin
export default {"root":"Bookmarks-module-root","wrapper":"Bookmarks-module-wrapper","title":"Bookmarks-module-title","item":"Bookmarks-module-item","empty":"Bookmarks-module-empty"};